import React from 'react';

function Quotes() {
  return (
    <section>
      <p>
        “Mathematics expresses values that reflect the cosmos, including
        orderliness, balance, harmony, logic, and abstract beauty.”
        {' '}
        <strong>― Deepak Chopra....</strong>
      </p>
    </section>
  );
}

export default Quotes;
